module.exports = __webpack_public_path__ + "bc4614974ae67511a0e30f1934a2585b.svg";